export class Locale {
    static getCurrencyFormatString(currency, number) {
        var userLang = navigator.language || navigator.userLanguage;
        return new Intl.NumberFormat(userLang, {
            style: 'currency',
            currency: currency,
        }).format(number);
    }

    static getNumberFormatString(number) {
        var userLang = navigator.language || navigator.userLanguage;
        return new Intl.NumberFormat(userLang, { minimumFractionDigits: 2 }).format(number);
    }
}
